import { cn } from "@utils/tw"
import { ComponentProps, useEffect, useLayoutEffect, useRef, useState } from "react"

type Props = ComponentProps<"div"> & {
  enabled?: boolean
}

export function StickyToFixed({ enabled, top, ...props }: Props) {
  const [fixed, setFixed] = useState(false)

  const outer = useRef<HTMLDivElement>(null)
  const inner = useRef<HTMLDivElement>(null)

  if (env.client) {
    useLayoutEffect(() => {
      if (!enabled) return

      const set = (fixed: boolean, height: number) => {
        outer.current?.style.setProperty("height", fixed ? height + "px" : "auto")
        inner.current?.style.setProperty("position", fixed ? "fixed" : "sticky")
      }

      const ro = new ResizeObserver((entries) => {
        set(true, entries[0].borderBoxSize[0].blockSize)
      })
      ro.observe(inner.current!)

      return () => {
        setFixed(false)
        ro.disconnect()
        set(true, 0)
      }
    }, [enabled])
  }

  return (
    <div ref={outer}>
      <div {...props} ref={inner} />
    </div>
  )
}
